module.exports = __webpack_public_path__ + "img/36.0a9a6340.png";